import React from 'react';

export default function Contact() {
  const handleBlogClick = (e) => {
    e.preventDefault();
    alert("Blog coming soon! I'll be sharing insights about protein design, research, and biotechnology.");
  };

  return (
    <section id="contact" className="section contact-section">
      <h2>Contact Me</h2>
      <p className="contact-intro">
        I'm always interested in discussing research opportunities, collaborations, 
        or answering questions about my work. Feel free to reach out!
      </p>
      
      <div className="contact-methods">
        <div className="contact-item">
          <h3>📧 Email</h3>
          <div className="email-group">
            <div className="email-item">
              <strong>Academic:</strong>
              <a href="mailto:als515@scarletmail.rutgers.edu">als515@scarletmail.rutgers.edu</a>
            </div>
            <div className="email-item">
              <strong>Personal:</strong>
              <a href="mailto:austin_seamann@icloud.com">austin_seamann@icloud.com</a>
            </div>
          </div>
        </div>

        <div className="contact-item">
          <h3>💼 LinkedIn</h3>
          <p>
            Connect with me on{' '}
            <a 
              href="https://www.linkedin.com/in/austin-seamann-ba199a257" 
              target="_blank" 
              rel="noopener noreferrer"
              className="linkedin-link"
            >
              LinkedIn
            </a>
            {' '}for professional networking and to stay updated on my research activities.
          </p>
        </div>

        <div className="contact-item">
          <h3>🎓 Academic Profile</h3>
          <p>
            View my publications and citations on{' '}
            <a 
              href="https://scholar.google.com/citations?user=QcDFDqMAAAAJ" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Google Scholar
            </a>
            .
          </p>
        </div>

        <div className="contact-item">
          <h3>📝 Blog</h3>
          <p>
            Read about my research insights and thoughts on{' '}
            <a 
              href="#" 
              onClick={handleBlogClick}
              className="blog-link"
            >
              my blog
            </a>
            {' '}(Coming Soon).
            {/* Original blog link: https://blog.austinseaman.com */}
          </p>
        </div>
      </div>

      <div className="contact-note">
        <p>
          <strong>Best for:</strong> Research inquiries → Academic email | 
          General questions → Personal email | 
          Professional networking → LinkedIn
        </p>
      </div>
    </section>
  );
}
